import React, { Component } from 'react';
import { PropTypes } from "Subschema";
import styles from "../labels/FloatingLabel.less";
import Transition from "react-addons-css-transition-group";
import _isFunction from "lodash/Lang/isFunction";


export default class DateOfBirthTemplate extends Component {

  constructor(props, ...rest) {
    super(props, ...rest);
    this.state = {
      dateOfBirthErrorMap: {
        dd: [],
        mm: [],
        yyyy: []
      }
    }
  }

  renderErrorList = () =>{

    const {
      ddError,
      mmError,
      yyyyError
    } = this.props;

    const errorArray = [
      ...(this.props.ddError === "paypalCreditData.dd" ? [] : this.props.ddError || []),
      ...(this.props.mmError === "paypalCreditData.mm" ? [] : this.props.mmError || []),
      ...(this.props.yyyyError === "paypalCreditData.yyyy" ? [] : this.props.yyyyError || [])
    ]

    return (
      <ul
        key="error"
        className={styles.combinedDobErrors}>
        {errorArray.map((errorMsg, index)=>{
          return(
            <li key={`error-${index}`}>
              {errorMsg}
            </li>)}
          )}
      </ul>)
  }

  renderErrorContainer = () => {
    return (
      <div
        className= {`${styles.hasGroup} ${styles.combinedDobContainer}`}>
        <div
          key="error"
          className={styles.hasMessage}>
            {this.renderErrorList()}
        </div>
      </div>)
  }

  render() {

    const {
      legend,
      content,
      legendClass,
      buttons,
      className,
      ...rest
    } =  {...this.props.field, ...this.props};

    return legend ?
      (<div>
        <fieldset
          className={className}>
          <legend
            className={legendClass}>
            {legend}
          </legend>
          {content}
          {this.props.children}
          {buttons}
        </fieldset>
      </div>) :
      (<div>
        <div className={className}>
          {this.props.children}
          <div
            className={`${styles.group} ${styles.select} ${styles.combinedDobErrorContainer}`}>
            {this.renderErrorContainer()}
          </div>
        </div>
      </div>)
  }
}


DateOfBirthTemplate.propTypes = {
  buttons: PropTypes.node,
  legend: PropTypes.node,
  className: PropTypes.cssClass,
  field: PropTypes.any,
  content: PropTypes.node,
  ddError: PropTypes.error,
  mmError: PropTypes.error,
  yyyyError: PropTypes.error
};


DateOfBirthTemplate.injectedProps = {
"ddError": "paypalCreditData.dd",
"mmError": "paypalCreditData.mm",
"yyyyError": "paypalCreditData.yyyy"
}



/** WEBPACK FOOTER **
 ** ./src/templates/DateOfBirthTemplate.jsx
 **/